import s from"react";import{cnJoin as t}from"../../utils/cssUtils/cssUtils.js";const e=({children:e,style:l,className:a})=>e?s.createElement("div",{"data-testid":"row",className:t("flex",a),style:l},e):null;export{e as default};
